export default () => ({
    restrict: 'E',
    template: "<div class='back tile' ng-transclude></div>",
    transclude: true,
});
